/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type StarHexMutationVariables = Types.Exact<{
  hexId: Types.Scalars["HexId"]["input"];
  starred: Types.Scalars["Boolean"]["input"];
}>;

export type StarHexMutation = {
  readonly __typename: "Mutation";
  readonly starHex: {
    readonly __typename: "Hex";
    readonly id: c.HexId;
    readonly starredByViewer: boolean;
  };
};

export const StarHexDocument = /*#__PURE__*/ gql`
  mutation starHex($hexId: HexId!, $starred: Boolean!) {
    starHex(hexId: $hexId, starred: $starred) {
      id
      starredByViewer
    }
  }
`;
export type StarHexMutationFn = Apollo.MutationFunction<
  StarHexMutation,
  StarHexMutationVariables
>;

/**
 * __useStarHexMutation__
 *
 * To run a mutation, you first call `useStarHexMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStarHexMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [starHexMutation, { data, loading, error }] = useStarHexMutation({
 *   variables: {
 *      hexId: // value for 'hexId'
 *      starred: // value for 'starred'
 *   },
 * });
 */
export function useStarHexMutation(
  baseOptions?: Apollo.MutationHookOptions<
    StarHexMutation,
    StarHexMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<StarHexMutation, StarHexMutationVariables>(
    StarHexDocument,
    options,
  );
}
export type StarHexMutationHookResult = ReturnType<typeof useStarHexMutation>;
export type StarHexMutationResult = Apollo.MutationResult<StarHexMutation>;
export type StarHexMutationOptions = Apollo.BaseMutationOptions<
  StarHexMutation,
  StarHexMutationVariables
>;
